export default "__VITE_ASSET__QtDjm$oy__"